import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function KaffiyehShemaghOversikt() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="41650" id="hero-introduktion" className="relative w-full min-h-[60vh] flex items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/robotaxi_hero.png)] overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-black/60" />

      <div ref={ref} className={`relative z-10 container mx-auto px-4 py-20 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-6 tracking-tight">
          Ledande plattform för Robotaxi-operatörer
        </h2>
        
        <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-10 leading-relaxed font-sans">
          Maximera din vinst och minimera riskerna med vår kompletta lösning för autonoma fordonsflottor. Från registrering till billigare försäkring och drift.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 border-none text-base px-8 h-12 rounded-sm shadow-md transition-all duration-300">
            <Link to="/BecomeOperatorPage">
              Bli Operatör
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}